import { SxProps } from "@mui/material"
import { colors } from "../../theme/colors"

export const rootSx: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "relative",
  height: 30,
  maxWidth: 440,
  padding: "0 20px",
  margin: "30px auto 0 auto",
}

export const pageTitleSx: SxProps = {
  maxWidth: "200px",
  fontWeight: "bolder",
  fontSize: 22,
  lineHeight: "28px",
  textAlign: "center",
  color: colors.lightBlack,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
}
